import { actionTypes } from '../actions/params';

// DEFAULT STATE
export const initParams = {
  apiUrl: '',
  email: '',
  token: '',
};

// WRITES
const params = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_API_URL:
      return Object.assign({}, state, {
        apiUrl: action.value,
      });
    default:
      return state;
  }
};

// READS
export const getApiUrl = (state) => state.params.apiUrl;
export const getEmail = (state) => state.params.email;
export const getToken = (state) => state.params.token;

export default params;
